import React from "react";
import { BottomButtons } from "./BottomButtons";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

import "./style.scss";

const DocPageComponent = ({ navigationBtns, titles, html, content }) => {
  const getTOC = (titles) => {
    if (titles.length === 0) {
      return false;
    } else {
      const toc = titles.map((title) => {
        return (
          <li key={title.id}>
            <a href={`#${title.outerText}`}>{title.outerText}</a>
          </li>
        );
      });
      return toc;
    }
  };
  const toc = getTOC(titles);

  return (
    <div className="main">
      {toc && (
        <div className="content__toc">
          <p>On this page</p>
          {toc}
        </div>
      )}
      <div className="content">
        <ReactMarkdown
          skipHtml
          remarkPlugins={[gfm]}
          rehypePlugins={[rehypeRaw]}
        >
          {content}
        </ReactMarkdown>
      </div>
      <div className="main__navigationBtns">
        {navigationBtns && <BottomButtons navigationBtns={navigationBtns} />}
      </div>
    </div>
  );
};
export default DocPageComponent;
